import { render, staticRenderFns } from "./AppBookingSideMenu.vue?vue&type=template&id=1456a672&scoped=true"
import script from "./AppBookingSideMenu.vue?vue&type=script&lang=js"
export * from "./AppBookingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AppBookingSideMenu.vue?vue&type=style&index=0&id=1456a672&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1456a672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1456a672')) {
      api.createRecord('1456a672', component.options)
    } else {
      api.reload('1456a672', component.options)
    }
    module.hot.accept("./AppBookingSideMenu.vue?vue&type=template&id=1456a672&scoped=true", function () {
      api.rerender('1456a672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/components/AppBookingSideMenu.vue"
export default component.exports